<template>
  <div id class="grey lighten-4">
    <send-notification></send-notification>
    <create-template></create-template>
    <v-container fluid class>
      <v-row>
        <v-col cols="12" md="3" lg="3" xl="2" class="pt-4">
          <admin-menu></admin-menu>
        </v-col>
        <v-col cols="12" md="9" lg="9" xl="10" class="pt-4">
          <transition name="slide-left">
            <router-view :key="$route.name"></router-view>
          </transition>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import store from "@/store";
import menu from "@/components/admin/menu";
import sendNotification from "@/components/admin/send-notification";
import createTemplate from "@/components/admin/create-template";

export default {
  name: "",
  components: {
    adminMenu: menu,
    sendNotification,
    createTemplate
  },
  beforeRouteEnter(to, from, next) {
    if (store.getters["isAdmin"]) {
      next();
    } else {
      next("/");
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  data: () => ({
    show_menu: true
  })
};
</script>
<style lang="scss" scoped>
</style>
